import { CssUtils } from "@opendaw/lib-dom";
export class ElementCapturing {
    #element;
    #capturing;
    constructor(element, capturing) {
        this.#element = element;
        this.#capturing = capturing;
    }
    get element() { return this.#element; }
    get capturing() { return this.#capturing; }
    captureEvent(event) {
        return this.capturePoint(event.clientX, event.clientY);
    }
    capturePoint(clientX, clientY) {
        const { left, top } = this.#element.getBoundingClientRect();
        const zoom = CssUtils.getDocumentZoom();
        return this.captureLocalPoint((clientX - left) / zoom, (clientY - top) / zoom);
    }
    captureLocalPoint(x, y) { return this.#capturing.capture(x, y); }
}
